


























import Vue from 'vue';

import { style } from '@/web/utils/stripe';
import auth from '@/core/api/modules/auth';

export default Vue.extend({
  data() {
    return {
      stripeCompleted: false,
      stripeError: false,
      inProgress: false,
    };
  },
  props: {
    plan: {
      type: Object,
      required: true,
    },
    subscriptionType: {
      type: String,
      required: true,
    },
    coupon: {
      type: String,
      required: false,
    },
  },
  methods: {
    stripeChangeCallback(event) {
      if (event.complete) {
        this.stripeCompleted = true;
        this.stripeError = false;
      } else if (event.error) {
        this.stripeCompleted = false;
        this.stripeError = event.error.message;
      }
    },
    initStripe() {
      this.stripe = window.Stripe(process.env.VUE_APP_STRIPE_PUBLIC);
      const elements = this.stripe.elements();
      this.card = elements.create('card', {
        style,
        hidePostalCode: true,
      });
      this.card.mount(this.$refs['card-element']);
      this.card.addEventListener('change', this.stripeChangeCallback);
    },
    async upgrade() {
      this.inProgress = true;
      const data = {
        plan_id: this.plan.id,
        subscription_type: this.subscriptionType,
        coupon: this.coupon,
      };

      try {
        const setupIntent = await auth.meTeacherSetupIntent();
        const confirmCard = await this.stripe.confirmCardSetup(
          setupIntent.setup_intent.client_secret,
          { payment_method: { card: this.card } }
        );

        data.default_payment_method = confirmCard.setupIntent.payment_method;
        await this.$store.dispatch('user/teacherSubscribe', data);

        this.$emit('close');
        this.$notify({
          group: 'app',
          type: 'success',
          text: this.$t('SETTINGS.TEXT.YOUR_PLAN_WAS_SUCCESSFULLY_UPGRADED'),
        });
      } catch (error) {
        this.$notify({
          group: 'app',
          type: 'error',
          text: this.$t('SETTINGS.TEXT.THERE_WAS_AN_ERROR_PROCESSING_PAYMENT'),
        });
      }
      this.inProgress = false;
      await this.$store.dispatch('user/loadUserInfo');
    },
  },
  mounted() {
    this.initStripe();
  },
});
